<script setup lang="ts">
import { StoredFile } from '@/store/common.interface';
import { Locales } from '@/store/language.interface';
import { getAltText } from '@/utils/image.helper';

const props = defineProps<{
  banner?: StoredFile;
  text: string;
  languageEnabled?: Locales[];
}>();
</script>

<template>
  <div class="description">
    <div class="description__content">
      <div class="description__content-image">
        <img
          v-if="banner?.url"
          :src="banner.url"
          :alt="getAltText(banner, 'alt-text.project.banner', languageEnabled)"
        />
      </div>
      <div class="description__content-text" v-html="props.text" />
    </div>
  </div>
</template>

<style lang="scss">
.description {
  &__content {
    display: flex;
    flex-direction: column;
    gap: $space-lg;

    &-image > img {
      width: 100%;
      height: auto;
      object-fit: cover;
      border-radius: 8px;
    }

    &-text {
      font-size: $body-text;
    }
  }
}
</style>
